import { AppStore, appStore } from './AppStore/AppStore';
import { DiamondsStore, diamondsStore } from './DiamondsStore/DiamondsStore';
import { DictionaryStore, dictionaryStore } from './DictionaryStore/DictionaryStore';

export class Store {
  readonly app: AppStore;
  readonly dictionary: DictionaryStore;
  readonly diamondsStore: DiamondsStore;

  constructor() {
    this.app = appStore;
    this.dictionary = dictionaryStore;
    this.diamondsStore = diamondsStore;
  }
}

const store = new Store();

export default store;
